// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Page_pageWrapper__bOTpd"};